var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list',_vm._l((_vm.zones),function(zone){return _c('v-list-item',{key:zone.id},[_c('v-list-item-avatar',[_c('v-icon',[_vm._v("map")])],1),_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(_vm._s(zone.name))]),_c('v-list-item-subtitle',[_vm._v(_vm._s(_vm.$t('maps.zone.zone')))])],1)],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }